'use strict';

/* eslint-disable */
var orderView = {};

orderView.init = function init() {
    function addOption(qty) {
        qty -= 1;

        if (qty == 0) {
            $('select.qty-select').filter(':first').removeClass('qty-select');
            return;
        }
        $('select.qty-select').filter(':first').append(new Option(qty, qty));
        addOption(qty);
    }

    $(document).ready(function () {
        $('select.qty-select').each(function () {
            addOption($(this).val());
        });

        $('select.typeOfReturn').each(function () {
            addReturnOption($(this));
        });
    });

    function addReturnOption(element) {
        var parent = element.closest('.register-return-select-fields')
        Object.keys(optionsData).forEach(function(key,index) {
            var option = optionsData[key];
            if (option.onlyInStock != true || parent.attr('data-in-stock') == "true") {
                var optionElement = document.createElement("option");
                optionElement.value = option.value;
                optionElement.textContent = option.label;
                element[0].appendChild(optionElement);
            }
        });
    }

    $('[data-select-all]').click(function () {
        $('[data-return-items] .register-return-item-name input:checkbox').not(this).prop('checked', this.checked);

        if ($(this).prop('checked')) {
            $('[data-return-items] .register-return-select-fields select').removeAttr('disabled');
            $('[data-return-items] .register-return-select-wrapper').addClass('opacity-full');
        } else {
            $('[data-return-items] .register-return-select-fields select').attr('disabled', 'disabled');
            $('[data-return-items] .register-return-select-wrapper').removeClass('opacity-full');
            $('[data-return-items] .register-return-select-fields .register-return-invalid-feedback').hide();
        }
    });

    $('[data-select-all-mobile]').click(function () {
        $('[data-return-items-mobile] .register-return-item-name input:checkbox').not(this).prop('checked', this.checked);

        if ($(this).prop('checked')) {
            $('[data-return-items-mobile] .register-return-select-fields select').removeAttr('disabled');
            $('[data-return-items-mobile] .register-return-select-wrapper').addClass('opacity-full');
        } else {
            $('[data-return-items-mobile] .register-return-select-fields select').attr('disabled', 'disabled');
            $('[data-return-items-mobile] .register-return-select-wrapper').removeClass('opacity-full');
            $('[data-return-items-mobile] .register-return-select-fields .register-return-invalid-feedback').hide();
        }
    });

    if ($('input[type="checkbox"]').hasClass('register-return-checkbox')) {
        $('input[type="checkbox"]').on('click', function () {
            var item = $(this).closest('.register-return-item');
            if (item.length == 0) {
                item = $(this).closest('.register-return-item-bundled');
            }
            if ($(this).prop('checked')) {
                item.find('.register-return-select-fields select').removeAttr('disabled');
                item.find('.register-return-select-wrapper').addClass('opacity-full');
            } else {
                item.find('.register-return-select-fields select').attr('disabled', 'disabled');
                item.find('.register-return-select-wrapper').removeClass('opacity-full');
                item.find('.register-return-invalid-feedback').hide();
            }
        });
    }

    $(document).on('change', '.typeOfReturn', function () {
        var parent = $(this).closest('.register-return-select-fields')
        var subOptionSelect = parent.find('.reasonOfReturn')[0];

        var options = optionsData;
        var selectedOption = this.value;

        if (selectedOption && options[selectedOption]) {
            subOptionSelect.innerHTML = selectedOption == 0 ? '' : '<option value="">' + options[0].label + '</option>'; // reset
            
            options[selectedOption].options.forEach(function (sub) {
                var option = document.createElement("option");
                option.value = sub.value;
                option.textContent = sub.label;
                subOptionSelect.appendChild(option);
            });
        }
    });

    $(document).on('click', '.unifaunLink', function () {
        var unifaunUrl = $('.unifaunUrl').data('unifaun');
        window.location.href = unifaunUrl;
    });

    $('.register-return-submit-button').on('click', function (e) {
        $('select.typeOfReturn:enabled').each(function () {
            toggleErrorMessage($(this), e);
        });

        $('select.reasonOfReturn:enabled').each(function () {
            toggleErrorMessage($(this), e);
        });

        var text = $('.register-return-description-text').val();
        var newText = text.replace(/[\r\n]+/gm, ' ');
        $('.register-return-description-text').val(newText);
    });

    function toggleErrorMessage(element, e) {
        var feedbackElement = element
                    .parent().parent()
                    .children('.register-return-invalid-feedback');
        if (element.val() === '' || element.val() == '0') {
            e.preventDefault();
            feedbackElement.show();
        } else {
            feedbackElement.hide();
        }
    }
};

module.exports = orderView;
